import { parseBoolean } from '@chatwoot/utils';
import { resolveMaximumFileUploadSize } from 'shared/helpers/FileHelper';

const {
  API_CHANNEL_NAME: apiChannelName,
  API_CHANNEL_THUMBNAIL: apiChannelThumbnail,
  APP_VERSION: appVersion,
  AZURE_APP_ID: azureAppId,
  BRAND_NAME: brandName,
  CHATWOOT_INBOX_TOKEN: chatwootInboxToken,
  CREATE_NEW_ACCOUNT_FROM_DASHBOARD: createNewAccountFromDashboard,
  DIRECT_UPLOADS_ENABLED: directUploadsEnabled,
  DISPLAY_MANIFEST: displayManifest,
  GIT_SHA: gitSha,
  MAXIMUM_FILE_UPLOAD_SIZE: maximumFileUploadSize,
  HCAPTCHA_SITE_KEY: hCaptchaSiteKey,
  INSTALLATION_NAME: installationName,
  LOGO_THUMBNAIL: logoThumbnail,
  LOGO: logo,
  LOGO_DARK: logoDark,
  PRIVACY_URL: privacyURL,
  IS_ENTERPRISE: isEnterprise,
  TERMS_URL: termsURL,
  WIDGET_BRAND_URL: widgetBrandURL,
  DISABLE_USER_PROFILE_UPDATE: disableUserProfileUpdate,
  DEPLOYMENT_ENV: deploymentEnv,
  ACTIVE_PLATFORM_BANNERS: activePlatformBanners,
  FENGHUAI_PRODUCT_PROFILE: fenghuaiProductProfile,
  FENGHUAI_VISIBLE_CHANNELS: fenghuaiVisibleChannels,
  FENGHUAI_ENABLE_WECHAT_MINI_PROGRAM: fenghuaiEnableWechatMiniProgram,
  FENGHUAI_ENABLE_WECOM: fenghuaiEnableWecom,
  FENGHUAI_ENABLE_AI_ASSISTANT: fenghuaiEnableAiAssistant,
  FENGHUAI_ENABLE_OVERSEAS_CHANNELS: fenghuaiEnableOverseasChannels,
  FENGHUAI_LOGIN_CAPTCHA_ENABLED: fenghuaiLoginCaptchaEnabled,
  FENGHUAI_LOGIN_CAPTCHA_PROVIDER: fenghuaiLoginCaptchaProvider,
  FENGHUAI_TURNSTILE_SITE_KEY: fenghuaiTurnstileSiteKey,
  FENGHUAI_TENCENT_CAPTCHA_APP_ID: fenghuaiTencentCaptchaAppId,
} = window.globalConfig || {};

const state = {
  apiChannelName,
  apiChannelThumbnail,
  appVersion,
  azureAppId,
  brandName,
  chatwootInboxToken,
  deploymentEnv,
  createNewAccountFromDashboard,
  directUploadsEnabled: parseBoolean(directUploadsEnabled),
  disableUserProfileUpdate: parseBoolean(disableUserProfileUpdate),
  displayManifest,
  gitSha,
  maximumFileUploadSize: resolveMaximumFileUploadSize(maximumFileUploadSize),
  hCaptchaSiteKey,
  installationName,
  logo,
  logoDark,
  logoThumbnail,
  privacyURL,
  termsURL,
  widgetBrandURL,
  isEnterprise: parseBoolean(isEnterprise),
  activePlatformBanners: activePlatformBanners || [],
  fenghuaiProductProfile,
  fenghuaiVisibleChannels: fenghuaiVisibleChannels || [],
  fenghuaiEnableWechatMiniProgram: parseBoolean(
    fenghuaiEnableWechatMiniProgram
  ),
  fenghuaiEnableWecom: parseBoolean(fenghuaiEnableWecom),
  fenghuaiEnableAiAssistant: parseBoolean(fenghuaiEnableAiAssistant),
  fenghuaiEnableOverseasChannels: parseBoolean(
    fenghuaiEnableOverseasChannels
  ),
  fenghuaiLoginCaptchaEnabled: parseBoolean(fenghuaiLoginCaptchaEnabled),
  fenghuaiLoginCaptchaProvider: fenghuaiLoginCaptchaProvider || 'turnstile',
  fenghuaiTurnstileSiteKey,
  fenghuaiTencentCaptchaAppId,
};

export const getters = {
  get: $state => $state,
  isOnChatwootCloud: $state => $state.deploymentEnv === 'cloud',
  isACustomBrandedInstance: $state => $state.installationName !== 'Chatwoot',
  isAChatwootInstance: $state => $state.installationName === 'Chatwoot',
};

export const actions = {};

export const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
